<template>
  <div class="mt-3">
    <h1>{{ id === '' ? 'Создание формы' : 'Редактирование формы' }}</h1>

    <b-form-group label-cols="2" label-cols-lg="2" label="Название:">
      <b-form-input v-model="title"></b-form-input>
    </b-form-group>
    <b-form-group label-cols="2" label-cols-lg="2" label="Шаблон:">
      <template v-if="!template"> <input type="file" style="display:none" id="upload_doc" @change="selectDoc" accept=".docx" /><label for="upload_doc" style="display:flex; cursor:pointer"><span class="material-icons">note_add</span>Добавить</label></template>
      <template v-else><a :href="templateURL"> {{ templateName }}</a> <span class="material-icons" style="cursor:pointer" @click="template=''">close</span></template>
    </b-form-group>

    <form-builder type="template" v-model="form_data"></form-builder>

    <div class="text-right my-3">
      <b-button variant="secondary" @click="reset" style="margin-right:2px">Сбросить</b-button>
      <b-button variant="success" @click="save_form" style="margin-left:2px">Сохранить</b-button>
    </div>
  </div>
</template>

<script>
import toastr from 'toastr';
import { uploadDocsApi } from '@app/services';

export default {
  data: () => ({
    id: '',
    title: '',
    form_data: null,
    template: '',
    templateName: '',
    templateURL: ''
  }),
  methods: {
    reset() {
      if (this.id) {
        this.load_latest_from();
      } else {
        this.form_data.type = '';
        this.form_data.sections = [];
        this.title = '';
      }
    },
    load_latest_from() {
      if (this.id) {
        var pageLoader = Vue.$loading.show();
        axios
          .get('/api/get_latest_form/' + this.id)
          .then(response => {
            if (response.data.result) {
              this.title = response.data.form.title;
              this.template = response.data.form.template;
              this.templateName = response.data.form.template.split('/')[response.data.form.template.split('/').length-1]; // 'Шаблон';
              if (this.template) {
                this.templateURL = process.env.VUE_APP_API_URL + this.template;
              }
              this.form_data = JSON.parse(response.data.form.data);
            } else {
              SethPhatToaster.error(response.data.msg);
              this.$router.push('/formbuilder/form');
            }
          })
          .catch(error => {
            //console.log(error);
            SethPhatToaster.error('Что-то пошло не так');
            this.$router.push('/formbuilder/form');
          })
          .finally(() => pageLoader.hide());
      }
    },
    save_form() {
      if (this.title === '') {
        SethPhatToaster.error('Введите название шаблона');
        return;
      }
      if (_.isEmpty(this.form_data) || _.isEmpty(this.form_data.sections)) {
        SethPhatToaster.error('Не была создана конфигурация!');
        return;
      }
      var pageLoader = Vue.$loading.show();
      var api_url = '';
      if (this.id !== '') {
        api_url = '/api/edit_form/' + this.id;
      } else {
        api_url = '/api/create_form/';
      }
      axios
        .post(api_url, {
          title: this.title,
          data: JSON.stringify(this.form_data),
          template: this.template ? this.template : ''
        })
        .then(response => {
          if (response.data.result) {
            SethPhatToaster.success(response.data.msg);
            this.$router.push('/formbuilder/form');
          } else {
            SethPhatToaster.error(response.data.msg);
          }
        })
        .catch(error => {
          //console.log(error);
          SethPhatToaster.error('Что-то пошло не так');
          this.$router.push('/formbuilder/form');
        })
        .finally(() => pageLoader.hide());
    },
    selectDoc(event) {
      if (event) { console.log(event);
        const headers = { 'Content-Type': 'multipart/form-data' };
        const files = event.target.files || event.dataTransfer.files;
        const file = files[0];
        this.templateName = file.name;
        const formData = new FormData();
        formData.append('file', file);
        uploadDocsApi.upload(formData).then(res => {
          this.template = res;
          this.templateURL = process.env.VUE_APP_API_URL + res;
        }).catch(error => {
          toastr.error('Ошибка загрузки');
        });
      }
    }
  },
  created() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.load_latest_from();
    }
  },
  beforeDestroy() {
    this.form_data = null;
  }
};
</script>

<style scoped></style>
